// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"b9d5b839","303":"b9d5b839","620":"1980c837","1003":"0e4810f7","1571":"b9d5b839","1776":"b9d5b839","2048":"0e4810f7","3752":"1871620d","3854":"9867b257","3935":"c3f7fbe0","8723":"b6c3218f","9306":"0e4810f7","9507":"0e4810f7"}[chunkId] + ".chunk.css";
};